import { PaginationResponse } from "models/pagination-response";
import { INewsPagedRequest } from "models/request/news-paged-request";
import { ICategoriesNewsListResponse } from "models/response/categories-news-list-response";
import { INewsPagedRespomse } from "models/response/news-paged-response";

export type NewsState = {
    news: PaginationResponse<INewsPagedRespomse>;
    newsPagedRequest: INewsPagedRequest;
    categoriesNews: ICategoriesNewsListResponse[];
    loading: boolean;
};

export enum ACTION_TYPES {
    setNews = 'setNews',
    setNewsPagedRequest = 'setNewsPagedRequest',
    setCategoriesNews = 'setCategoriesNews',
    setLoading = 'setLoading',
}

export const NewsReducer = (state: NewsState, action: any): NewsState => {
    const { type, payload } = action;
    switch (type) {

        case ACTION_TYPES.setNewsPagedRequest:
            return {
                ...state,
                newsPagedRequest: payload,
            };

        case ACTION_TYPES.setNews:
            return {
                ...state,
                news: payload,
            };
        case ACTION_TYPES.setCategoriesNews:
            return {
                ...state,
                categoriesNews: payload,
            };
        case ACTION_TYPES.setLoading:
            return {
                ...state,
                loading: payload,
            };
 
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}